// extracted by mini-css-extract-plugin
export default {"noData":"noData_noData__4E-OH"};